import type { ClFormProps } from './types'

export const initialFormValues: ClFormProps = {
  profitCenter: '',
  businessUnit: 'Todos',
  segment: 'Todos',
  directorate: 'Todos'
}
